<template>
  <div>
    <el-button
      @click="clickBtn(item)"
      v-for="item in btnList"
      :key="item.filed"
    >
      {{ item.label }}
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    btnList() {
      return this.list;
    },
    itemData() {
      return this.item;
    },
  },
  methods: {
    clickBtn(item) {
      this.$emit("clickBtn", item);
    },
  },
};
</script>
